import { useEffect } from 'react';

const FOCUSABLE = 'a[href], button:not(:disabled), input:not(:disabled), textarea:not(:disabled), select:not(:disabled), [tabindex]:not([tabindex="-1"])';

export default function useFocusTrap(containerRef, active = true) {
  useEffect(() => {
    if (!active) return;
    const container = containerRef.current;
    if (!container) return;

    const previouslyFocused = document.activeElement;

    const focusables = () => [...container.querySelectorAll(FOCUSABLE)];
    // A [data-autofocus] element wins initial focus (a dialog's close button
    // is often first in DOM order but never the right place to start typing).
    // React's autoFocus prop never reaches the DOM, hence the data attribute.
    const initial = container.querySelector('[data-autofocus]') || focusables()[0];
    initial?.focus();

    const handleKeyDown = (e) => {
      if (e.key !== 'Tab') return;
      const els = focusables();
      if (!els.length) return;

      const firstEl = els[0];
      const lastEl = els[els.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === firstEl) {
          e.preventDefault();
          lastEl.focus();
        }
      } else {
        if (document.activeElement === lastEl) {
          e.preventDefault();
          firstEl.focus();
        }
      }
    };

    container.addEventListener('keydown', handleKeyDown);
    return () => {
      container.removeEventListener('keydown', handleKeyDown);
      if (previouslyFocused instanceof HTMLElement) {
        previouslyFocused.focus();
      }
    };
  }, [containerRef, active]);
}
